let jw = null

export async function getJW () {
  jw = window.jw
  if (!jw) {
    await require('https://www.joywok.com/public/scripts/jssdk.js')
    jw = window.jw
  }
  return jw
}

export function setup () {

}
